import { useState } from 'react'
import styled from 'styled-components'
import {
  TextSubHeading,
  TextBody,
  colors,
  IconDown,
  IconUp,
  Link as BuiLink,
} from '@blocket/blocket-ui'
import { mediaQueries } from 'plugins/device'
import {
  trackReviewsInfoAreaExpand,
  trackReviewsInfoAreaClickLink,
} from '/tracking/profilePagePublic'
import { localStorageSetItem, localStorageGetItem } from 'utils/useLocalStorage'
import useOnMount from 'customHooks/useOnMount'

const Wrapper = styled.div`
  background-color: ${colors.blue50};
  padding: 16px;
  margin-top: 20px;
  border-left: 5px solid ${colors.blue800};
  border-radius: 5px;
  @media ${mediaQueries.large} {
    margin-top: 38px;
  }
`

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: baseline;
`

const SubHeading = styled(TextSubHeading)`
  color: ${colors.blue800};
`

const ArrowButton = styled.button`
  width: auto;
  cursor: pointer;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  margin-right: 20px;
`

const TextRow = styled.div`
  display: flex;
  flex-flow: wrap;
  margin-bottom: 16px;
`

const Text = styled(TextBody)`
  color: ${colors.blue800};
`

const TextBold = styled(Text)`
  font-weight: bold;
`

const TextWithMargin = styled(Text)`
  margin: 0 4px;
`

const Link = styled(BuiLink)`
  text-decoration: underline;
`

const ReviewsInfo = () => {
  const [openInfo, setOpenInfo] = useState(false)
  const ArrowIcon = openInfo ? IconUp : IconDown

  useOnMount(() => {
    const shown = localStorageGetItem('reviewsInfoShown')
    if (!shown) {
      setOpenInfo(true)
      localStorageSetItem('reviewsInfoShown', true)
    }
  })

  const openCloseInfoArea = () => {
    if (!openInfo) {
      // we want to see if users open the info again
      trackReviewsInfoAreaExpand()
    }
    setOpenInfo(!openInfo)
  }

  return (
    <Wrapper>
      <RowWrapper>
        <ArrowButton onClick={openCloseInfoArea}>
          <ArrowIcon color={colors.blue800} width={16} height={16} />
        </ArrowButton>
        <TextWrapper>
          {!openInfo ? (
            <SubHeading>Om omdömen på Blocket</SubHeading>
          ) : (
            <>
              <TextRow>
                <Text>
                  Du får möjlighet att lämna omdömen när du använt någon av Blockets tjänster (
                </Text>
                <TextBold>Köp med frakt och köpskydd </TextBold>
                <TextWithMargin> eller </TextWithMargin>
                <TextBold> Köp direkt </TextBold>
                <Text>).</Text>
              </TextRow>
              <TextRow>
                <Text>
                  Båda parter är alltid verifierade och motparten ser aldrig ditt omdömen förrän de
                  lämnat sitt.
                </Text>
              </TextRow>
              <Link
                href="https://blocket.zendesk.com/hc/sv/articles/6899760601500-S%C3%A5-fungerar-omd%C3%B6men-p%C3%A5-Blocket"
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackReviewsInfoAreaClickLink}
              >
                Läs mer om omdömen på Blocket.
              </Link>
            </>
          )}
        </TextWrapper>
      </RowWrapper>
    </Wrapper>
  )
}

export default ReviewsInfo
